import React from "react";
import { BrowserRouter, Routes } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { getRoutes } from "./routes";

function AppRoutes() {
  const { user } = useAuth();
  return <Routes>{getRoutes(user)}</Routes>;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}

